import { useState } from "react"
import { Badge, Button, Modal } from "react-bootstrap"
import toast from "react-hot-toast"

import LoadingTextSwap from "../LoadingTextSwap"
import { useMarkUserPaidMutation } from "../../app/adminApiSlice"
import ButtonWithTooltip from "./ButtonWithTooltip"

interface MarkPaidBadgeProps {
  userId: string
  userName: string
}

const MarkPaidBadge = ({ userId, userName }: MarkPaidBadgeProps) => {
  const [markUserPaid, { isLoading }] = useMarkUserPaidMutation()
  const [show, setShow] = useState(false)

  const handleShow = () => setShow(true)
  const handleClose = () => setShow(false)

  const now = new Date()
  const currentYear = now.getFullYear()
  const septemberFirst = new Date(currentYear, 8, 1)
  const validUntilYear = now < septemberFirst ? currentYear : currentYear + 1

  const handleConfirm = async () => {
    try {
      await markUserPaid({ id: userId }).unwrap()
      toast.success("User marked as paid")
      handleClose()
    } catch (error) {
      console.log(error)
      toast.error("An error occurred")
      handleClose()
    }
  }

  return (
    <>
      <ButtonWithTooltip text="Click to mark as paid">
        <Badge
          className="fw-semibold fs-8 shadow-btn"
          bg="danger"
          onClick={handleShow}
          role="button"
          style={{ cursor: "pointer" }}
        >
          Due
        </Badge>
      </ButtonWithTooltip>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="border-0 p-0 mb-2">
          <Modal.Title className="fs-5 fw-bold">Mark user as paid?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-muted fs-7 mb-3">
          <strong className="text-dark">{userName}</strong> will be marked as paid until{" "}
          <strong className="text-dark">1st October {validUntilYear}</strong>.
        </Modal.Body>
        <Modal.Footer className="p-0 border-0">
          <Button
            disabled={isLoading}
            className="rounded-3 m-0 fs-7 me-2"
            variant="dark"
            style={{ width: "100px" }}
            onClick={handleConfirm}
          >
            <LoadingTextSwap isLoading={isLoading}>Continue</LoadingTextSwap>
          </Button>
          <Button
            className="shadow-btn rounded-3 border-1 m-0 border-light fs-7"
            variant="white"
            style={{ width: "100px" }}
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default MarkPaidBadge